import React from 'react';
import { CustomerChatWidgetSettingsSection as OldCustomerChatWidgetSettingsSection } from '../../../../configure/panels/sections/CustomerChatWidgetSettingsSection/CustomerChatWidgetSettingsSection';

export const CustomerChatWidget = () => {
  return <OldCustomerChatWidgetSettingsSection />;
};
